import _ from 'lodash'
import api, { formCfg, listDehydrate } from './api'
import apiFactory from './api-factory'
import { dehydrate as progressDehydrate } from './progress'
import { dehydrate as userDehydrate } from './user'

const poll = {
  ...apiFactory('/api/polls/poll/', ['getDetail', 'getList', 'delete'], {
    dehydrate,
  }),

  getListByRole(role, pk, params, context) {
    return api
      .get(`/api/polls/poll/?for_${role}=${pk}`, formCfg(params, context))
      .then((response) => listDehydrate(response.data, dehydrate))
  },

  getExtendedList(params, context) {
    return api
      .get('/api/polls/poll/extended/', formCfg(params, context))
      .then((response) => listDehydrate(response.data, dehydrate))
  },

  patchAvailability(pk, availability, params, context) {
    return api.patch(
      `/api/polls/poll/${pk}/availability/`,
      hydrate(availability),
      formCfg(params, context)
    )
  },

  patchIsActive(pk, isActive, params, context) {
    return api.patch(
      `/api/polls/poll/${pk}/is_active/`,
      hydrate({ isActive }),
      formCfg(params, context)
    )
  },

  export(pk, language) {
    return api
      .get(`/polls/poll_manager/export/${pk}/?language=${language}`)
      .then((response) => response.data)
  },
}

export function dehydrate({
  pk,
  name,
  type,
  description,
  isDisabled,
  isExternal,
  createdBy,
  dateModified,
  tooltip,
  branchingQuestion,
  progress,
  entriesCount,
  lastSubmittedYamlPoll,
  requiredEntryTagGroups,
  optionalEntryTagGroups,
}) {
  return {
    type: 'polls',
    pk,
    name,
    description,
    pollType: type,
    tooltip,
    isEnabled: !isDisabled,
    isExternal,
    createdBy: createdBy ? userDehydrate(createdBy) : null,
    dateModified,
    entriesCount,
    progress: progress ? progressDehydrate(progress) : null,
    branchingQuestion,
    lastSubmittedYamlPoll,
    requiredEntryTagGroups,
    optionalEntryTagGroups,
  }
}

function hydrate({ isEnabled }) {
  const params = {}

  if (_.isBoolean(isEnabled)) {
    params.isDisabled = !isEnabled
  }

  return params
}

export default poll
